function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 23.456c5.799 0 10.5-4.701 10.5-10.5s-4.701-10.5-10.5-10.5-10.5 4.701-10.5 10.5 4.701 10.5 10.5 10.5zm-3-15v9l7.5-4.5-7.5-4.5z",
  fill: "#81858D"
});

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyMy40NTYxQzE3Ljc5OSAyMy40NTYxIDIyLjUgMTguNzU1IDIyLjUgMTIuOTU2MUMyMi41IDcuMTU3MDYgMTcuNzk5IDIuNDU2MDUgMTIgMi40NTYwNUM2LjIwMTAxIDIuNDU2MDUgMS41IDcuMTU3MDYgMS41IDEyLjk1NjFDMS41IDE4Ljc1NSA2LjIwMTAxIDIzLjQ1NjEgMTIgMjMuNDU2MVpNOSA4LjQ1NjA1VjE3LjQ1NjFMMTYuNSAxMi45NTYxTDkgOC40NTYwNVoiIGZpbGw9IiM4MTg1OEQiLz4KPC9zdmc+";
export { SvgPlay as ReactComponent };